<script>
export default {
  props: {
    type: String,
    text: String,
    long: [Boolean, String],
    large: [Boolean, String],
    full: [String, Boolean],
    processing: Boolean,
    disabled: [String, Boolean],
    brand: [String, Boolean],
    textColor: [String, Boolean],
  },
  computed: {
    tailwindClasses() {
      let classes = ['md_py-_5 xl_py-1 px-2_25 md_px-2_25 xl_px-4'];

      if (this.large) {
        classes.push('py-1_5');
      } else {
        classes.push('py-1');
      }

      if (this.long) {
        classes.push('w-3-5');
      }

      if (this.type === 'submit') {
        classes = [...classes, 'bg-brand', 'text-white', 'hover_bg-brand-900']
      } else {
        let color = this.brand ? 'brand' : 'white',
          textColor = this.brand ? 'text-white' : 'text-brand-secondary-900',
          hoverClass = this.brand ? 'hover_bg-brand-900' : '';

        classes = [...classes, `bg-${color}`, `border-${color}`, hoverClass, textColor];
      }

      if (this.full) {
        classes = [...classes, 'w-full'];
      }

      return classes;
    },
    classes() {
      let classes = [];

      if (this.processing) {
        classes.push('buyer-button--loading');
      }

      if (this.type === 'submit') {
        classes.push('buyer-button--submit');
      }

      return [...this.tailwindClasses, ...classes];
    }
  },
};
</script>

<template lang='pug'>
button.buyer-button.relative.font-bold.text-lg.md_text-sm.border-2.border-transparent(
  :type='type || "button"',
  :class='classes',
  :disabled='disabled',
  :style='{ color: textColor }',
  @click='$emit("click", $event)',
  @keyup.enter='$emit("click", $event)',
)
  span {{text}}
  .loader.w-2.h-2.absolute.border-2.border-white.rounded-4(v-show='processing')
  .absolute.border.h-full.w-full.buyer-button__border.border-inherit(v-if='type !== "submit"')
</template>

<style>
@import '~import/index';

.buyer-button {
  $self: &;
  transition: transform 100ms linear;

  &__border {
    left: 0;
    top: 0;
    transform: translate(5px, 5px);
    transition: transform 100ms linear;
  }

  &--loading {
    >span {
      visibility: hidden;
    }
  }

  &:not(#{$self}--submit):hover,
  &:not(#{$self}--submit):active {
    transform: translate(2.5px, 2.5px);

    #{$self}__border {
      transform: translate(0px, 0px);
    }
  }
}
</style>